/**
 * readFormDeriveRecordProp
 *
 * Reads one `FormDeriveReferenceProp` off a referenced EntityRecord, LIVE.
 * The `reference` arm yields the referenced record's `entityRecordId` STRING,
 * never the reference object: that is the value every other consumer of a form
 * field expects, and it is the same read the retired form-level `elementMapping`
 * mechanism performed. Copying the object instead would also churn the hash on
 * every re-save of the referenced record, whose `meta` timestamp moves without
 * the identity moving. Consumers: `computeFormDerives` and `ledgerEngine`'s
 * `evaluateLedgerAccrualBinding`.
 */

import type { FormDeriveReferenceProp } from '../System.FormDerive.types';
import type { FormDeriveRecordInput } from './computeFormDerives';

function readFormDeriveRecordProp(
  record: NonNullable<FormDeriveRecordInput>,
  prop: FormDeriveReferenceProp,
): unknown {
  if (prop.kind === 'name') return record.name;
  if (prop.kind === 'field') return record.fields?.[prop.fieldId]?.value;
  return record.entityReferences?.[prop.referenceKey]?.entityRecordId;
}

export { readFormDeriveRecordProp };
